<template>
  <kst-page-report 
    :catalog="TrxSearchCatalog"
    :params="Model.UrlParams"
    :search="searchData"
    @init="handleInit"
    @load="handleLoad"
    @reset="handleReset"
  >
    <template #search="{ handleInput }">
      <Search
        :searchData="searchData"
        :warehouseOptions="warehouseOptions"
        @input="handleInput"
      />
    </template>

    <template #search-result="{ data }">
      <Result
        :access="access"
        :items="data.List"
      />
    </template>
  </kst-page-report>
</template>

<script>
import Model from "../TrxModel.js";
import Services from "../../../services/Api/TransactionServices.js";
import TrxSearchCatalog from "../TrxSearchCatalog.js";

import Result from "./TrxR_Result.vue";
import Search from "./TrxR_Search.vue";

export default {
  components: {
    Result,
    Search
  },
  data: () => ({
    Model: Model,
    TrxSearchCatalog: TrxSearchCatalog,
    access: {},
    searchData: {
      Date: null,
      ItemID: null,
      WarehouseID: null,
      TransactionTypeID: null,
      // support
      ItemName: null
    },
    warehouseOptions: {}
  }),
  created() {
    this.resetSearch();
  },
  methods: {
    /*** by page ***/

    handleInit(loadReportData) {
      this.resetData();

      const options = this.getListOptions();
      const config = Services.getReportData(options);
      loadReportData(config, this.handleInit_Success);
    },
    handleInit_Success(data) {
      this.searchData.ItemName = data.Search.ItemName;
      this.warehouseOptions = Model.getWarehouseOptions(
        data.WarehouseList, TrxSearchCatalog.WarehouseID.Label
      );
    },

    handleLoad(loadReport) {
      const options = this.getListOptions();
      const config = Services.getReport(options);
      loadReport(config);
    },

    handleReset() {
      this.resetSearch();
    },

    /*** custom ***/

    resetData() {
      this.access = this.$kst.Access.create(Model.Access);
      this.warehouseOptions = {};

      this.normalizeSearch();
    },
    normalizeSearch() {
      if (this.searchData.WarehouseID === null) {
        this.searchData.WarehouseID = this.$kst.Session.getDefaultWarehouseID();
      }
    },
    resetSearch() {
      this.searchData.Date = this.$kst.In.getDefaultDateRange();
      this.searchData.ItemID = null;
      this.searchData.WarehouseID = this.$kst.Session.getDefaultWarehouseID();
      this.searchData.TransactionTypeID = this.$kst.Search.OptionAll;
      // support
      this.searchData.ItemName = null;
    },

    getListOptions() {
      return {
        item: this.$kst.Out.getInteger(this.searchData.ItemID),
        warehouse: this.$kst.Search.getValue(this.searchData.WarehouseID),
        transactiontype: this.$kst.Search.getValue(
          this.searchData.TransactionTypeID),
        startdate: this.$kst.Out.getDateString(this.searchData.Date[0]),
        enddate: this.$kst.Out.getDateString(this.searchData.Date[1])
      };
    }
  }
}
</script>